import BreakpointDisplay from './BreakpointDisplay'

export default BreakpointDisplay
